// extracted by mini-css-extract-plugin
module.exports = {"BaseLayout":"BaseLayout_BaseLayout__19oTw","BaseLayout__Footer":"BaseLayout_BaseLayout__Footer__4TWT6"};